import type { LinkNavTab } from '@shared/ui/menus'

import { resolveUrl } from '@shared/lib/url'
import { AppRoute } from '@shared/config'

import { useLessonPrivileges } from './lesson-privileges.hook'
import { useDisciplinePrivileges } from '../discipline-privileges.hook'

interface LessonEditMenuReturn {
  config: ComputedRef<LinkNavTab[]>
}

/** The lesson page tabs: the lesson itself with its connection status and tutor feedback, and the connection log
 *  (its own read, so it stays a tab). */
export const useLessonEditMenu = (): LessonEditMenuReturn => {
  const route = useRoute()
  const { canViewPaidBookings } = useLessonPrivileges()
  const { canViewDisciplines } = useDisciplinePrivileges()

  const params = { id: route.params.id as string, lessonId: route.params.lessonId as string }

  const singleUrl = resolveUrl(AppRoute.LessonsEdit, params) ?? ''
  const connectionLogUrl = resolveUrl(AppRoute.LessonsConnectionLog, params) ?? ''

  const config = computed<LinkNavTab[]>(() => [
    {
      text: 'General info',
      to: singleUrl,
      selected: route.path === singleUrl,
      disabled: false,
      visible: true,
    },
    {
      text: 'Connection log',
      to: connectionLogUrl,
      selected: route.path === connectionLogUrl,
      disabled: false,
      // The log needs both rights; without them the API answers 403.
      visible: canViewDisciplines.value && canViewPaidBookings.value,
    },
  ])

  return {
    config,
  }
}
